import _is from "../value/is";
import _is2 from "../object/is";
import _coerce from "../string/coerce";
import _toShortString from "./to-short-string";
var exports = {};
var isValue = _is,
    isObject = _is2,
    stringCoerce = _coerce,
    toShortString = _toShortString;

var resolveMessage = function (message, value) {
  return message.replace("%v", toShortString(value));
};

exports = function (value, defaultMessage, inputOptions) {
  if (!isObject(inputOptions)) throw new TypeError(resolveMessage(defaultMessage, value));

  if (!isValue(value)) {
    if ("default" in inputOptions) return inputOptions["default"];
    if (inputOptions.isOptional) return null;
  }

  var errorMessage = stringCoerce(inputOptions.errorMessage);
  if (!isValue(errorMessage)) errorMessage = defaultMessage;
  throw new TypeError(resolveMessage(errorMessage, value));
};

export default exports;